/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DatabaseUsageOut,
  HTTPValidationError,
  JobIn,
  JobsOut,
  JobsPausedIn,
  ListPlatformJobRunsParams,
  ListPlatformOrgsParams,
  ListSupportSessionsParams,
  MessageResponse,
  NewCustomerIn,
  NewCustomerOut,
  PaginatedJobRunOut,
  PaginatedPlatformOrgOut,
  PaginatedSupportSessionOut,
  PlatformDiagnosticsOut,
  PlatformSecurityIn,
  PlatformSettingsOut,
  PlatformStatusOut,
  PlatformSummaryOut,
  SupportActionsOut,
  SupportSessionOut,
  SupportStartIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type getPlatformSummaryResponse200 = {
  data: PlatformSummaryOut
  status: 200
}

export type getPlatformSummaryResponseSuccess = (getPlatformSummaryResponse200) & {
  headers: Headers;
};
;

export type getPlatformSummaryResponse = (getPlatformSummaryResponseSuccess)

export const getGetPlatformSummaryUrl = () => {




  return `/api/platform/summary`
}

/**
 * @summary Get Platform Summary
 */
export const getPlatformSummary = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformSummaryResponse> => {

  return apiFetch<getPlatformSummaryResponse>(getGetPlatformSummaryUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformSummaryQueryKey = () => {
    return [
    `/api/platform/summary`
    ] as const;
    }


export const getGetPlatformSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformSummary>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformSummaryQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformSummary>>> = ({ signal }) => getPlatformSummary({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformSummary>>>
export type GetPlatformSummaryQueryError = unknown


export function useGetPlatformSummary<TData = Awaited<ReturnType<typeof getPlatformSummary>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSummary>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSummary<TData = Awaited<ReturnType<typeof getPlatformSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSummary>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSummary<TData = Awaited<ReturnType<typeof getPlatformSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform Summary
 */

export function useGetPlatformSummary<TData = Awaited<ReturnType<typeof getPlatformSummary>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSummary>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformSummaryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPlatformOrgsResponse200 = {
  data: PaginatedPlatformOrgOut
  status: 200
}

export type listPlatformOrgsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPlatformOrgsResponseSuccess = (listPlatformOrgsResponse200) & {
  headers: Headers;
};
export type listPlatformOrgsResponseError = (listPlatformOrgsResponse422) & {
  headers: Headers;
};

export type listPlatformOrgsResponse = (listPlatformOrgsResponseSuccess | listPlatformOrgsResponseError)

export const getListPlatformOrgsUrl = (params?: ListPlatformOrgsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/orgs?${stringifiedParams}` : `/api/platform/orgs`
}

/**
 * @summary List Platform Orgs
 */
export const listPlatformOrgs = async (params?: ListPlatformOrgsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listPlatformOrgsResponse> => {

  return apiFetch<listPlatformOrgsResponse>(getListPlatformOrgsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformOrgsQueryKey = (params?: ListPlatformOrgsParams,) => {
    return [
    `/api/platform/orgs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlatformOrgsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformOrgs>>, TError = HTTPValidationError>(params?: ListPlatformOrgsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformOrgsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformOrgs>>> = ({ signal }) => listPlatformOrgs(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatformOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformOrgs>>>
export type ListPlatformOrgsQueryError = HTTPValidationError


export function useListPlatformOrgs<TData = Awaited<ReturnType<typeof listPlatformOrgs>>, TError = HTTPValidationError>(
 params: undefined |  ListPlatformOrgsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformOrgs>>,
          TError,
          Awaited<ReturnType<typeof listPlatformOrgs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformOrgs<TData = Awaited<ReturnType<typeof listPlatformOrgs>>, TError = HTTPValidationError>(
 params?: ListPlatformOrgsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformOrgs>>,
          TError,
          Awaited<ReturnType<typeof listPlatformOrgs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformOrgs<TData = Awaited<ReturnType<typeof listPlatformOrgs>>, TError = HTTPValidationError>(
 params?: ListPlatformOrgsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Platform Orgs
 */

export function useListPlatformOrgs<TData = Awaited<ReturnType<typeof listPlatformOrgs>>, TError = HTTPValidationError>(
 params?: ListPlatformOrgsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformOrgs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatformOrgsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type addCustomerResponse201 = {
  data: NewCustomerOut
  status: 201
}

export type addCustomerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addCustomerResponseSuccess = (addCustomerResponse201) & {
  headers: Headers;
};
export type addCustomerResponseError = (addCustomerResponse422) & {
  headers: Headers;
};

export type addCustomerResponse = (addCustomerResponseSuccess | addCustomerResponseError)

export const getAddCustomerUrl = () => {




  return `/api/platform/orgs`
}

/**
 * @summary Add Customer
 */
export const addCustomer = async (newCustomerIn: NewCustomerIn, options?: Parameters<typeof apiFetch>[1]): Promise<addCustomerResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addCustomerResponse>(getAddCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newCustomerIn)
  }
);}





export const getAddCustomerMutationKey = () => ['addCustomer'] as const;

export const getAddCustomerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomer>>, TError,AddCustomerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCustomer>>, TError,AddCustomerMutationVariables, TContext> => {

const mutationKey = getAddCustomerMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCustomer>>, AddCustomerMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  addCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof addCustomer>>>
    export type AddCustomerMutationBody = NewCustomerIn
    export type AddCustomerMutationError = HTTPValidationError
    export type AddCustomerMutationVariables = {data: NewCustomerIn}

    /**
 * @summary Add Customer
 */
export const useAddCustomer = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCustomer>>, TError,AddCustomerMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCustomer>>,
        TError,
        AddCustomerMutationVariables,
        TContext
      > => {
      return useMutation(getAddCustomerMutationOptions(options), queryClient);
    }
    export type getPlatformSettingsResponse200 = {
  data: PlatformSettingsOut
  status: 200
}

export type getPlatformSettingsResponseSuccess = (getPlatformSettingsResponse200) & {
  headers: Headers;
};
;

export type getPlatformSettingsResponse = (getPlatformSettingsResponseSuccess)

export const getGetPlatformSettingsUrl = () => {




  return `/api/platform/settings`
}

/**
 * @summary Get Platform Settings
 */
export const getPlatformSettings = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformSettingsResponse> => {

  return apiFetch<getPlatformSettingsResponse>(getGetPlatformSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformSettingsQueryKey = () => {
    return [
    `/api/platform/settings`
    ] as const;
    }


export const getGetPlatformSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformSettings>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformSettings>>> = ({ signal }) => getPlatformSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformSettings>>>
export type GetPlatformSettingsQueryError = unknown


export function useGetPlatformSettings<TData = Awaited<ReturnType<typeof getPlatformSettings>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSettings>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSettings<TData = Awaited<ReturnType<typeof getPlatformSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformSettings>>,
          TError,
          Awaited<ReturnType<typeof getPlatformSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformSettings<TData = Awaited<ReturnType<typeof getPlatformSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform Settings
 */

export function useGetPlatformSettings<TData = Awaited<ReturnType<typeof getPlatformSettings>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformSettings>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setPlatformSecurityResponse200 = {
  data: PlatformSettingsOut
  status: 200
}

export type setPlatformSecurityResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setPlatformSecurityResponseSuccess = (setPlatformSecurityResponse200) & {
  headers: Headers;
};
export type setPlatformSecurityResponseError = (setPlatformSecurityResponse422) & {
  headers: Headers;
};

export type setPlatformSecurityResponse = (setPlatformSecurityResponseSuccess | setPlatformSecurityResponseError)

export const getSetPlatformSecurityUrl = () => {




  return `/api/platform/settings/security`
}

/**
 * @summary Set Platform Security
 */
export const setPlatformSecurity = async (platformSecurityIn: PlatformSecurityIn, options?: Parameters<typeof apiFetch>[1]): Promise<setPlatformSecurityResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setPlatformSecurityResponse>(getSetPlatformSecurityUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(platformSecurityIn)
  }
);}





export const getSetPlatformSecurityMutationKey = () => ['setPlatformSecurity'] as const;

export const getSetPlatformSecurityMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformSecurity>>, TError,SetPlatformSecurityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPlatformSecurity>>, TError,SetPlatformSecurityMutationVariables, TContext> => {

const mutationKey = getSetPlatformSecurityMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPlatformSecurity>>, SetPlatformSecurityMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setPlatformSecurity(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPlatformSecurityMutationResult = NonNullable<Awaited<ReturnType<typeof setPlatformSecurity>>>
    export type SetPlatformSecurityMutationBody = PlatformSecurityIn
    export type SetPlatformSecurityMutationError = HTTPValidationError
    export type SetPlatformSecurityMutationVariables = {data: PlatformSecurityIn}

    /**
 * @summary Set Platform Security
 */
export const useSetPlatformSecurity = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformSecurity>>, TError,SetPlatformSecurityMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPlatformSecurity>>,
        TError,
        SetPlatformSecurityMutationVariables,
        TContext
      > => {
      return useMutation(getSetPlatformSecurityMutationOptions(options), queryClient);
    }
    export type getPlatformStatusResponse200 = {
  data: PlatformStatusOut
  status: 200
}

export type getPlatformStatusResponseSuccess = (getPlatformStatusResponse200) & {
  headers: Headers;
};
;

export type getPlatformStatusResponse = (getPlatformStatusResponseSuccess)

export const getGetPlatformStatusUrl = () => {




  return `/api/platform/status`
}

/**
 * @summary Get Platform Status
 */
export const getPlatformStatus = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformStatusResponse> => {

  return apiFetch<getPlatformStatusResponse>(getGetPlatformStatusUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformStatusQueryKey = () => {
    return [
    `/api/platform/status`
    ] as const;
    }


export const getGetPlatformStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformStatus>>> = ({ signal }) => getPlatformStatus({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformStatus>>>
export type GetPlatformStatusQueryError = unknown


export function useGetPlatformStatus<TData = Awaited<ReturnType<typeof getPlatformStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformStatus>>,
          TError,
          Awaited<ReturnType<typeof getPlatformStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformStatus<TData = Awaited<ReturnType<typeof getPlatformStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformStatus>>,
          TError,
          Awaited<ReturnType<typeof getPlatformStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformStatus<TData = Awaited<ReturnType<typeof getPlatformStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform Status
 */

export function useGetPlatformStatus<TData = Awaited<ReturnType<typeof getPlatformStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformStatus>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPlatformDiagnosticsResponse200 = {
  data: PlatformDiagnosticsOut
  status: 200
}

export type getPlatformDiagnosticsResponseSuccess = (getPlatformDiagnosticsResponse200) & {
  headers: Headers;
};
;

export type getPlatformDiagnosticsResponse = (getPlatformDiagnosticsResponseSuccess)

export const getGetPlatformDiagnosticsUrl = () => {




  return `/api/platform/diagnostics`
}

/**
 * @summary Get Platform Diagnostics
 */
export const getPlatformDiagnostics = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformDiagnosticsResponse> => {

  return apiFetch<getPlatformDiagnosticsResponse>(getGetPlatformDiagnosticsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformDiagnosticsQueryKey = () => {
    return [
    `/api/platform/diagnostics`
    ] as const;
    }


export const getGetPlatformDiagnosticsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDiagnosticsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformDiagnostics>>> = ({ signal }) => getPlatformDiagnostics({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformDiagnosticsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformDiagnostics>>>
export type GetPlatformDiagnosticsQueryError = unknown


export function useGetPlatformDiagnostics<TData = Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDiagnostics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDiagnostics<TData = Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDiagnostics>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDiagnostics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDiagnostics<TData = Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform Diagnostics
 */

export function useGetPlatformDiagnostics<TData = Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDiagnostics>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDiagnosticsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPlatformJobsResponse200 = {
  data: JobsOut
  status: 200
}

export type listPlatformJobsResponseSuccess = (listPlatformJobsResponse200) & {
  headers: Headers;
};
;

export type listPlatformJobsResponse = (listPlatformJobsResponseSuccess)

export const getListPlatformJobsUrl = () => {




  return `/api/platform/jobs`
}

/**
 * @summary List Platform Jobs
 */
export const listPlatformJobs = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listPlatformJobsResponse> => {

  return apiFetch<listPlatformJobsResponse>(getListPlatformJobsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformJobsQueryKey = () => {
    return [
    `/api/platform/jobs`
    ] as const;
    }


export const getListPlatformJobsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformJobs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformJobsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformJobs>>> = ({ signal }) => listPlatformJobs({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatformJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformJobs>>>
export type ListPlatformJobsQueryError = unknown


export function useListPlatformJobs<TData = Awaited<ReturnType<typeof listPlatformJobs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformJobs>>,
          TError,
          Awaited<ReturnType<typeof listPlatformJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformJobs<TData = Awaited<ReturnType<typeof listPlatformJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformJobs>>,
          TError,
          Awaited<ReturnType<typeof listPlatformJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformJobs<TData = Awaited<ReturnType<typeof listPlatformJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Platform Jobs
 */

export function useListPlatformJobs<TData = Awaited<ReturnType<typeof listPlatformJobs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobs>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatformJobsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updatePlatformJobResponse200 = {
  data: JobsOut
  status: 200
}

export type updatePlatformJobResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updatePlatformJobResponseSuccess = (updatePlatformJobResponse200) & {
  headers: Headers;
};
export type updatePlatformJobResponseError = (updatePlatformJobResponse422) & {
  headers: Headers;
};

export type updatePlatformJobResponse = (updatePlatformJobResponseSuccess | updatePlatformJobResponseError)

export const getUpdatePlatformJobUrl = (name: string,) => {




  return `/api/platform/jobs/${name}`
}

/**
 * @summary Update Platform Job
 */
export const updatePlatformJob = async (name: string,
    jobIn: JobIn, options?: Parameters<typeof apiFetch>[1]): Promise<updatePlatformJobResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updatePlatformJobResponse>(getUpdatePlatformJobUrl(name),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobIn)
  }
);}





export const getUpdatePlatformJobMutationKey = () => ['updatePlatformJob'] as const;

export const getUpdatePlatformJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformJob>>, TError,UpdatePlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePlatformJob>>, TError,UpdatePlatformJobMutationVariables, TContext> => {

const mutationKey = getUpdatePlatformJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePlatformJob>>, UpdatePlatformJobMutationVariables> = (props) => {
          const {name,data} = props ?? {};

          return  updatePlatformJob(name,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePlatformJobMutationResult = NonNullable<Awaited<ReturnType<typeof updatePlatformJob>>>
    export type UpdatePlatformJobMutationBody = JobIn
    export type UpdatePlatformJobMutationError = HTTPValidationError
    export type UpdatePlatformJobMutationVariables = {name: string;data: JobIn}

    /**
 * @summary Update Platform Job
 */
export const useUpdatePlatformJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePlatformJob>>, TError,UpdatePlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePlatformJob>>,
        TError,
        UpdatePlatformJobMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePlatformJobMutationOptions(options), queryClient);
    }
    export type runPlatformJobResponse200 = {
  data: JobsOut
  status: 200
}

export type runPlatformJobResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type runPlatformJobResponseSuccess = (runPlatformJobResponse200) & {
  headers: Headers;
};
export type runPlatformJobResponseError = (runPlatformJobResponse422) & {
  headers: Headers;
};

export type runPlatformJobResponse = (runPlatformJobResponseSuccess | runPlatformJobResponseError)

export const getRunPlatformJobUrl = (name: string,) => {




  return `/api/platform/jobs/${name}/run`
}

/**
 * @summary Run Platform Job
 */
export const runPlatformJob = async (name: string, options?: Parameters<typeof apiFetch>[1]): Promise<runPlatformJobResponse> => {

  return apiFetch<runPlatformJobResponse>(getRunPlatformJobUrl(name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRunPlatformJobMutationKey = () => ['runPlatformJob'] as const;

export const getRunPlatformJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPlatformJob>>, TError,RunPlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runPlatformJob>>, TError,RunPlatformJobMutationVariables, TContext> => {

const mutationKey = getRunPlatformJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runPlatformJob>>, RunPlatformJobMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  runPlatformJob(name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunPlatformJobMutationResult = NonNullable<Awaited<ReturnType<typeof runPlatformJob>>>

    export type RunPlatformJobMutationError = HTTPValidationError
    export type RunPlatformJobMutationVariables = {name: string}

    /**
 * @summary Run Platform Job
 */
export const useRunPlatformJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runPlatformJob>>, TError,RunPlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runPlatformJob>>,
        TError,
        RunPlatformJobMutationVariables,
        TContext
      > => {
      return useMutation(getRunPlatformJobMutationOptions(options), queryClient);
    }
    export type stopPlatformJobResponse200 = {
  data: JobsOut
  status: 200
}

export type stopPlatformJobResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type stopPlatformJobResponseSuccess = (stopPlatformJobResponse200) & {
  headers: Headers;
};
export type stopPlatformJobResponseError = (stopPlatformJobResponse422) & {
  headers: Headers;
};

export type stopPlatformJobResponse = (stopPlatformJobResponseSuccess | stopPlatformJobResponseError)

export const getStopPlatformJobUrl = (name: string,) => {




  return `/api/platform/jobs/${name}/stop`
}

/**
 * @summary Stop Platform Job
 */
export const stopPlatformJob = async (name: string, options?: Parameters<typeof apiFetch>[1]): Promise<stopPlatformJobResponse> => {

  return apiFetch<stopPlatformJobResponse>(getStopPlatformJobUrl(name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStopPlatformJobMutationKey = () => ['stopPlatformJob'] as const;

export const getStopPlatformJobMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopPlatformJob>>, TError,StopPlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof stopPlatformJob>>, TError,StopPlatformJobMutationVariables, TContext> => {

const mutationKey = getStopPlatformJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof stopPlatformJob>>, StopPlatformJobMutationVariables> = (props) => {
          const {name} = props ?? {};

          return  stopPlatformJob(name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StopPlatformJobMutationResult = NonNullable<Awaited<ReturnType<typeof stopPlatformJob>>>

    export type StopPlatformJobMutationError = HTTPValidationError
    export type StopPlatformJobMutationVariables = {name: string}

    /**
 * @summary Stop Platform Job
 */
export const useStopPlatformJob = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof stopPlatformJob>>, TError,StopPlatformJobMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof stopPlatformJob>>,
        TError,
        StopPlatformJobMutationVariables,
        TContext
      > => {
      return useMutation(getStopPlatformJobMutationOptions(options), queryClient);
    }
    export type setPlatformJobsPausedResponse200 = {
  data: JobsOut
  status: 200
}

export type setPlatformJobsPausedResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setPlatformJobsPausedResponseSuccess = (setPlatformJobsPausedResponse200) & {
  headers: Headers;
};
export type setPlatformJobsPausedResponseError = (setPlatformJobsPausedResponse422) & {
  headers: Headers;
};

export type setPlatformJobsPausedResponse = (setPlatformJobsPausedResponseSuccess | setPlatformJobsPausedResponseError)

export const getSetPlatformJobsPausedUrl = () => {




  return `/api/platform/job-controls/paused`
}

/**
 * @summary Set Platform Jobs Paused
 */
export const setPlatformJobsPaused = async (jobsPausedIn: JobsPausedIn, options?: Parameters<typeof apiFetch>[1]): Promise<setPlatformJobsPausedResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setPlatformJobsPausedResponse>(getSetPlatformJobsPausedUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobsPausedIn)
  }
);}





export const getSetPlatformJobsPausedMutationKey = () => ['setPlatformJobsPaused'] as const;

export const getSetPlatformJobsPausedMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformJobsPaused>>, TError,SetPlatformJobsPausedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPlatformJobsPaused>>, TError,SetPlatformJobsPausedMutationVariables, TContext> => {

const mutationKey = getSetPlatformJobsPausedMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPlatformJobsPaused>>, SetPlatformJobsPausedMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  setPlatformJobsPaused(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPlatformJobsPausedMutationResult = NonNullable<Awaited<ReturnType<typeof setPlatformJobsPaused>>>
    export type SetPlatformJobsPausedMutationBody = JobsPausedIn
    export type SetPlatformJobsPausedMutationError = HTTPValidationError
    export type SetPlatformJobsPausedMutationVariables = {data: JobsPausedIn}

    /**
 * @summary Set Platform Jobs Paused
 */
export const useSetPlatformJobsPaused = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPlatformJobsPaused>>, TError,SetPlatformJobsPausedMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPlatformJobsPaused>>,
        TError,
        SetPlatformJobsPausedMutationVariables,
        TContext
      > => {
      return useMutation(getSetPlatformJobsPausedMutationOptions(options), queryClient);
    }
    export type listPlatformJobRunsResponse200 = {
  data: PaginatedJobRunOut
  status: 200
}

export type listPlatformJobRunsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPlatformJobRunsResponseSuccess = (listPlatformJobRunsResponse200) & {
  headers: Headers;
};
export type listPlatformJobRunsResponseError = (listPlatformJobRunsResponse422) & {
  headers: Headers;
};

export type listPlatformJobRunsResponse = (listPlatformJobRunsResponseSuccess | listPlatformJobRunsResponseError)

export const getListPlatformJobRunsUrl = (params?: ListPlatformJobRunsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/job-runs?${stringifiedParams}` : `/api/platform/job-runs`
}

/**
 * @summary List Platform Job Runs
 */
export const listPlatformJobRuns = async (params?: ListPlatformJobRunsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listPlatformJobRunsResponse> => {

  return apiFetch<listPlatformJobRunsResponse>(getListPlatformJobRunsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPlatformJobRunsQueryKey = (params?: ListPlatformJobRunsParams,) => {
    return [
    `/api/platform/job-runs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPlatformJobRunsQueryOptions = <TData = Awaited<ReturnType<typeof listPlatformJobRuns>>, TError = HTTPValidationError>(params?: ListPlatformJobRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPlatformJobRunsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPlatformJobRuns>>> = ({ signal }) => listPlatformJobRuns(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPlatformJobRunsQueryResult = NonNullable<Awaited<ReturnType<typeof listPlatformJobRuns>>>
export type ListPlatformJobRunsQueryError = HTTPValidationError


export function useListPlatformJobRuns<TData = Awaited<ReturnType<typeof listPlatformJobRuns>>, TError = HTTPValidationError>(
 params: undefined |  ListPlatformJobRunsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformJobRuns>>,
          TError,
          Awaited<ReturnType<typeof listPlatformJobRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformJobRuns<TData = Awaited<ReturnType<typeof listPlatformJobRuns>>, TError = HTTPValidationError>(
 params?: ListPlatformJobRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPlatformJobRuns>>,
          TError,
          Awaited<ReturnType<typeof listPlatformJobRuns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPlatformJobRuns<TData = Awaited<ReturnType<typeof listPlatformJobRuns>>, TError = HTTPValidationError>(
 params?: ListPlatformJobRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Platform Job Runs
 */

export function useListPlatformJobRuns<TData = Awaited<ReturnType<typeof listPlatformJobRuns>>, TError = HTTPValidationError>(
 params?: ListPlatformJobRunsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPlatformJobRuns>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPlatformJobRunsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getPlatformDatabaseUsageResponse200 = {
  data: DatabaseUsageOut
  status: 200
}

export type getPlatformDatabaseUsageResponseSuccess = (getPlatformDatabaseUsageResponse200) & {
  headers: Headers;
};
;

export type getPlatformDatabaseUsageResponse = (getPlatformDatabaseUsageResponseSuccess)

export const getGetPlatformDatabaseUsageUrl = () => {




  return `/api/platform/database`
}

/**
 * @summary Get Platform Database Usage
 */
export const getPlatformDatabaseUsage = async ( options?: Parameters<typeof apiFetch>[1]): Promise<getPlatformDatabaseUsageResponse> => {

  return apiFetch<getPlatformDatabaseUsageResponse>(getGetPlatformDatabaseUsageUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPlatformDatabaseUsageQueryKey = () => {
    return [
    `/api/platform/database`
    ] as const;
    }


export const getGetPlatformDatabaseUsageQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformDatabaseUsageQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>> = ({ signal }) => getPlatformDatabaseUsage({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPlatformDatabaseUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>>
export type GetPlatformDatabaseUsageQueryError = unknown


export function useGetPlatformDatabaseUsage<TData = Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDatabaseUsage>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDatabaseUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDatabaseUsage<TData = Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformDatabaseUsage>>,
          TError,
          Awaited<ReturnType<typeof getPlatformDatabaseUsage>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlatformDatabaseUsage<TData = Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Platform Database Usage
 */

export function useGetPlatformDatabaseUsage<TData = Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlatformDatabaseUsage>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPlatformDatabaseUsageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type sendTestEmailResponse200 = {
  data: MessageResponse
  status: 200
}

export type sendTestEmailResponseSuccess = (sendTestEmailResponse200) & {
  headers: Headers;
};
;

export type sendTestEmailResponse = (sendTestEmailResponseSuccess)

export const getSendTestEmailUrl = () => {




  return `/api/platform/diagnostics/test-email`
}

/**
 * @summary Send Test Email
 */
export const sendTestEmail = async ( options?: Parameters<typeof apiFetch>[1]): Promise<sendTestEmailResponse> => {

  return apiFetch<sendTestEmailResponse>(getSendTestEmailUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSendTestEmailMutationKey = () => ['sendTestEmail'] as const;

export const getSendTestEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestEmail>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof sendTestEmail>>, TError,void, TContext> => {

const mutationKey = getSendTestEmailMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendTestEmail>>, void> = () => {


          return  sendTestEmail(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendTestEmailMutationResult = NonNullable<Awaited<ReturnType<typeof sendTestEmail>>>

    export type SendTestEmailMutationError = unknown


    /**
 * @summary Send Test Email
 */
export const useSendTestEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendTestEmail>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendTestEmail>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getSendTestEmailMutationOptions(options), queryClient);
    }
    export type startSupportSessionResponse201 = {
  data: SupportSessionOut
  status: 201
}

export type startSupportSessionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type startSupportSessionResponseSuccess = (startSupportSessionResponse201) & {
  headers: Headers;
};
export type startSupportSessionResponseError = (startSupportSessionResponse422) & {
  headers: Headers;
};

export type startSupportSessionResponse = (startSupportSessionResponseSuccess | startSupportSessionResponseError)

export const getStartSupportSessionUrl = () => {




  return `/api/platform/support`
}

/**
 * @summary Start Support Session
 */
export const startSupportSession = async (supportStartIn: SupportStartIn, options?: Parameters<typeof apiFetch>[1]): Promise<startSupportSessionResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<startSupportSessionResponse>(getStartSupportSessionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(supportStartIn)
  }
);}





export const getStartSupportSessionMutationKey = () => ['startSupportSession'] as const;

export const getStartSupportSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSupportSession>>, TError,StartSupportSessionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startSupportSession>>, TError,StartSupportSessionMutationVariables, TContext> => {

const mutationKey = getStartSupportSessionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startSupportSession>>, StartSupportSessionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  startSupportSession(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartSupportSessionMutationResult = NonNullable<Awaited<ReturnType<typeof startSupportSession>>>
    export type StartSupportSessionMutationBody = SupportStartIn
    export type StartSupportSessionMutationError = HTTPValidationError
    export type StartSupportSessionMutationVariables = {data: SupportStartIn}

    /**
 * @summary Start Support Session
 */
export const useStartSupportSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startSupportSession>>, TError,StartSupportSessionMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startSupportSession>>,
        TError,
        StartSupportSessionMutationVariables,
        TContext
      > => {
      return useMutation(getStartSupportSessionMutationOptions(options), queryClient);
    }
    export type endSupportSessionResponse204 = {
  data: void
  status: 204
}

export type endSupportSessionResponseSuccess = (endSupportSessionResponse204) & {
  headers: Headers;
};
;

export type endSupportSessionResponse = (endSupportSessionResponseSuccess)

export const getEndSupportSessionUrl = () => {




  return `/api/platform/support`
}

/**
 * @summary End Support Session
 */
export const endSupportSession = async ( options?: Parameters<typeof apiFetch>[1]): Promise<endSupportSessionResponse> => {

  return apiFetch<endSupportSessionResponse>(getEndSupportSessionUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getEndSupportSessionMutationKey = () => ['endSupportSession'] as const;

export const getEndSupportSessionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endSupportSession>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof endSupportSession>>, TError,void, TContext> => {

const mutationKey = getEndSupportSessionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endSupportSession>>, void> = () => {


          return  endSupportSession(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndSupportSessionMutationResult = NonNullable<Awaited<ReturnType<typeof endSupportSession>>>

    export type EndSupportSessionMutationError = unknown


    /**
 * @summary End Support Session
 */
export const useEndSupportSession = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endSupportSession>>, TError,void, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof endSupportSession>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getEndSupportSessionMutationOptions(options), queryClient);
    }
    export type listSupportSessionsResponse200 = {
  data: PaginatedSupportSessionOut
  status: 200
}

export type listSupportSessionsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listSupportSessionsResponseSuccess = (listSupportSessionsResponse200) & {
  headers: Headers;
};
export type listSupportSessionsResponseError = (listSupportSessionsResponse422) & {
  headers: Headers;
};

export type listSupportSessionsResponse = (listSupportSessionsResponseSuccess | listSupportSessionsResponseError)

export const getListSupportSessionsUrl = (params?: ListSupportSessionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/platform/support?${stringifiedParams}` : `/api/platform/support`
}

/**
 * @summary List Support Sessions
 */
export const listSupportSessions = async (params?: ListSupportSessionsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listSupportSessionsResponse> => {

  return apiFetch<listSupportSessionsResponse>(getListSupportSessionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupportSessionsQueryKey = (params?: ListSupportSessionsParams,) => {
    return [
    `/api/platform/support`, ...(params ? [params] : [])
    ] as const;
    }


export const getListSupportSessionsQueryOptions = <TData = Awaited<ReturnType<typeof listSupportSessions>>, TError = HTTPValidationError>(params?: ListSupportSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupportSessionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupportSessions>>> = ({ signal }) => listSupportSessions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSupportSessionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSupportSessions>>>
export type ListSupportSessionsQueryError = HTTPValidationError


export function useListSupportSessions<TData = Awaited<ReturnType<typeof listSupportSessions>>, TError = HTTPValidationError>(
 params: undefined |  ListSupportSessionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportSessions>>,
          TError,
          Awaited<ReturnType<typeof listSupportSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportSessions<TData = Awaited<ReturnType<typeof listSupportSessions>>, TError = HTTPValidationError>(
 params?: ListSupportSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportSessions>>,
          TError,
          Awaited<ReturnType<typeof listSupportSessions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportSessions<TData = Awaited<ReturnType<typeof listSupportSessions>>, TError = HTTPValidationError>(
 params?: ListSupportSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Support Sessions
 */

export function useListSupportSessions<TData = Awaited<ReturnType<typeof listSupportSessions>>, TError = HTTPValidationError>(
 params?: ListSupportSessionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportSessions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSupportSessionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listSupportActionsResponse200 = {
  data: SupportActionsOut
  status: 200
}

export type listSupportActionsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listSupportActionsResponseSuccess = (listSupportActionsResponse200) & {
  headers: Headers;
};
export type listSupportActionsResponseError = (listSupportActionsResponse422) & {
  headers: Headers;
};

export type listSupportActionsResponse = (listSupportActionsResponseSuccess | listSupportActionsResponseError)

export const getListSupportActionsUrl = (sessionId: number,) => {




  return `/api/platform/support/${sessionId}/actions`
}

/**
 * @summary List Support Actions
 */
export const listSupportActions = async (sessionId: number, options?: Parameters<typeof apiFetch>[1]): Promise<listSupportActionsResponse> => {

  return apiFetch<listSupportActionsResponse>(getListSupportActionsUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListSupportActionsQueryKey = (sessionId: number,) => {
    return [
    `/api/platform/support/${sessionId}/actions`
    ] as const;
    }


export const getListSupportActionsQueryOptions = <TData = Awaited<ReturnType<typeof listSupportActions>>, TError = HTTPValidationError>(sessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListSupportActionsQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSupportActions>>> = ({ signal }) => listSupportActions(sessionId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListSupportActionsQueryResult = NonNullable<Awaited<ReturnType<typeof listSupportActions>>>
export type ListSupportActionsQueryError = HTTPValidationError


export function useListSupportActions<TData = Awaited<ReturnType<typeof listSupportActions>>, TError = HTTPValidationError>(
 sessionId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportActions>>,
          TError,
          Awaited<ReturnType<typeof listSupportActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportActions<TData = Awaited<ReturnType<typeof listSupportActions>>, TError = HTTPValidationError>(
 sessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSupportActions>>,
          TError,
          Awaited<ReturnType<typeof listSupportActions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListSupportActions<TData = Awaited<ReturnType<typeof listSupportActions>>, TError = HTTPValidationError>(
 sessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Support Actions
 */

export function useListSupportActions<TData = Awaited<ReturnType<typeof listSupportActions>>, TError = HTTPValidationError>(
 sessionId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSupportActions>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSupportActionsQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






